import { createStore } from 'react-sweet-state';

import type { FeedbackStoreActions } from './FeedbackStoreActions';
import type { FeedbackStoreState } from './FeedbackStoreState';

export const store: ReturnType<typeof createStore<FeedbackStoreState, FeedbackStoreActions>> =
	createStore<FeedbackStoreState, FeedbackStoreActions>({
		initialState: {
			isOpen: false,
			feedbackData: {
				answerQuality: 'general',
			},
		},
		actions: {
			open:
				(payload) =>
				({ setState }) => {
					setState({ isOpen: true, feedbackData: payload });
				},
			close:
				() =>
				({ setState }) => {
					setState({
						isOpen: false,
						feedbackData: {
							answerQuality: 'general',
						},
					});
				},
		},
	});
